"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7436],{

/***/ 97436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82222);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _services_home__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66156);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13135);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44012);
/* eslint-disable */ 








var OverallRating = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(5400)]).then(__webpack_require__.bind(__webpack_require__, 25400));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25400)
            ];
        }
    }
});
var Reviews = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 3141).then(__webpack_require__.bind(__webpack_require__, 63141));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63141)
            ];
        }
    }
});
var ClientReviews = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]), googleReviewsData = ref[0], setGoogleReviewsData = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), showReviews = ref1[0], setShowReviews = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0), rating = ref2[0], setRating = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0), numberOfReviews = ref3[0], setNumberOfReviews = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        var getGoogleReviews = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                var googleReviewsRes, googleReviewsData;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,_services_home__WEBPACK_IMPORTED_MODULE_1__/* .getBrandReviews */ .k5)()
                            ];
                        case 1:
                            googleReviewsRes = _state.sent();
                            googleReviewsData = googleReviewsRes.status === _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .SUCCESS_CODE */ .Gh ? googleReviewsRes === null || googleReviewsRes === void 0 ? void 0 : googleReviewsRes.data : null;
                            setGoogleReviewsData(googleReviewsData === null || googleReviewsData === void 0 ? void 0 : googleReviewsData.highlightedReviews);
                            setRating(googleReviewsData === null || googleReviewsData === void 0 ? void 0 : googleReviewsData.averageRating);
                            setNumberOfReviews(googleReviewsData === null || googleReviewsData === void 0 ? void 0 : googleReviewsData.numberOfReviews);
                            return [
                                2
                            ];
                    }
                });
            });
            return function getGoogleReviews() {
                return _ref.apply(this, arguments);
            };
        }();
        getGoogleReviews();
        displayReviews();
    }, []);
    var displayReviews = function() {
        // Hide reviews when no data found
        var getType = typeof googleReviewsData === "undefined" ? "undefined" : (0,_swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(googleReviewsData);
        if (getType === "string") {
            setShowReviews(false);
        } else if (googleReviewsData && googleReviewsData.length < 3) {
            setShowReviews(true);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: showReviews ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: "reviews",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "section-heading",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            id: "client-reviews"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "review-cards d-none d-lg-block d-md-none",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "row justify-content-center g-3",
                            children: googleReviewsData && (googleReviewsData === null || googleReviewsData === void 0 ? void 0 : googleReviewsData.length) && (googleReviewsData === null || googleReviewsData === void 0 ? void 0 : googleReviewsData.map(function(data, index) {
                                return index < 3 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Reviews, {
                                    data: data
                                }, index);
                            }))
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "review-cards d-none d-lg-none d-md-block",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "row justify-content-center g-3",
                            children: googleReviewsData && (googleReviewsData === null || googleReviewsData === void 0 ? void 0 : googleReviewsData.length) && (googleReviewsData === null || googleReviewsData === void 0 ? void 0 : googleReviewsData.map(function(data, index) {
                                return index < 2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Reviews, {
                                    data: data
                                }, index);
                            }))
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "review-cards d-block d-lg-none d-md-none",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "row justify-content-center g-3",
                            children: googleReviewsData && (googleReviewsData === null || googleReviewsData === void 0 ? void 0 : googleReviewsData.length) && (googleReviewsData === null || googleReviewsData === void 0 ? void 0 : googleReviewsData.map(function(data, index) {
                                return index === 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Reviews, {
                                    data: data
                                }, index);
                            }))
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(OverallRating, {
                        rating: rating,
                        numberOfReviews: numberOfReviews
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ClientReviews);


/***/ }),

/***/ 82222:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};


/***/ })

}]);